import { ref, computed } from 'vue';

export function useHttpReferrer() {
  const cookiePromocode = useCookie('c');
  const cookieCodeSent = useCookie('code_sended');

  const referrer = ref(document?.referrer);
  const currentUrl = ref(`${window?.location.protocol}//${window?.location.host}`);
  const promocode = computed(() => cookiePromocode.value);

  const queryRefParams = computed(() => {
    if (process.client) {
      const referrerValue = sessionStorage?.getItem('httpReferrer') ?? '';
      return (referrerValue || promocode.value)
        ? `?referrer=${referrerValue}&code=${promocode.value}`
        : '';
    } else {
      return '';
    }
  });
  const isAnotherReferrer = computed(() => {
    return referrer.value.indexOf(currentUrl.value) === -1;
  });

  const isRefClickSended = computed(() => {
    if (process.client) {
      return !!sessionStorage?.getItem('httpReferrer') && !!sessionStorage?.getItem('code');
    }
    else {
      return false;
    }
  });

  function saveToStorage(name: string, value: string) {
    if (process.client) {
      sessionStorage?.setItem(name, value);
    }
  }

  async function sendReferrer() {
    if (checkReferrer()) {
      await useApi().apiService.post('user/http/referer', { http_referer: referrer.value })
      saveToStorage('httpReferrer', referrer.value);
    }
  }

  async function sendPromoCodeAndRef() {
    if (useCookie('c').value && !cookieCodeSent.value) {
      const data = {
        code: String(useCookie('c').value),
        http_referer: referrer.value,
      };
      await useApi().apiService.post('promo/code/ref/click', data)
      cookieCodeSent.value = '1';
      saveToStorage('code', String(useCookie('c').value));
    }
  }

  function checkReferrer() {
    if (process.client) {
      const isSended = !!sessionStorage?.getItem('httpReferrer');
      return referrer.value && isAnotherReferrer.value && !isSended;
    }
    return false;
  }

  return {
    queryRefParams,
    referrer,
    currentUrl,
    promocode,
    isRefClickSended,
    sendReferrer,
    sendPromoCodeAndRef,
  };
}